export const DEFAULT_COLOR = '#000000';
export const DEFAULT_NEW_LEVEL_COLOR = '#CCCCCC99';
export const DEFAULT_NEW_LIKELIHOOD_COLOR = '#CCCCCC';
export const UNMATCHED_SCORE_COLOR = '#F3F4F6';
